webpackJsonp([7],{

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__ = __webpack_require__(347);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5427861b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__ = __webpack_require__(370);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Link_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5427861b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { EventBus } from '../../core/event-bus.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProyectoLink',
  props: ['codigo_proyecto'],
  data: function data() {
    return {
      data: null,
      error: null,
      loading: true
    };
  },
  mounted: function mounted() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getProyectoLink(this.codigo_proyecto, 'link').then(function (data) {
      vm.data = data;
      vm.loading = false;
    }, function (error) {
      vm.error = error.message;
      vm.loading = false;
    });
  },

  methods: {}
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('bounce-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),(_vm.data)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"pull-left",attrs:{"id":"proy-code"}},[_vm._v("\n        "+_vm._s(_vm.data.cta_text)+"\n        "),_c('a',{attrs:{"href":_vm.data.cta_link_or_iframe_src,"target":"_blank"}},[_c('i',{staticClass:"fa fa-external-link-alt"})])])])]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h1',{staticClass:"pull-left",attrs:{"id":"proy-code"}},[_vm._v(_vm._s(_vm.codigo_proyecto))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.04569ba885990efeda05.js